import { query, getHash } from './util.bom';

const _userAgent = navigator.userAgent.toLowerCase() || '';

export function isMacClient() {
  return /EduMac/i.test(_userAgent);
}

export function isWinClient() {
  const CallHummerApi = window.external && window.external.CallHummerApi;
  return /EduWin/i.test(_userAgent) || /TXEdu/i.test(_userAgent) || !!CallHummerApi;
}

export function isPCClient() {
  return isMacClient() || isWinClient() || !!getHash('client');
}

// 是否mac极简版
export function isMacClientLite() {
  return isMacClient() && /EduLite/.test(navigator.userAgent);
}

// 是否mac极简版
export function isWinClientLite() {
  return isWinClient() && /EduLite/.test(navigator.userAgent);
}

export function isIOS() {
  if (/iPhone|iPod/i.test(_userAgent)) {
    return true;
  }
  return false;
}

export function isAndroid() {
  if (_userAgent.indexOf('android') > 0) {
    return true;
  }
  return false;
}

export function isWeixin() {
  return _userAgent.indexOf('micromessenger') != -1;
}
export function qqVersion() {
  const _match = _userAgent.match(/qq\/(\d+\.\d+(\.\d+)?)/i);
  return (_match && _match[1]) || 0;
}

export function isApp() {
  return _userAgent.indexOf('educationapp') != -1 || _userAgent.indexOf('eduapp') != -1;
}
export function isBaiduApp() {
  return _userAgent.indexOf('baiduboxapp') != -1;
}
export function isWeiboApp() {
  return _userAgent.indexOf(' weibo ') != -1;
}
export function isMiniProgram() {
  const isMp = !!window.location.search.match(new RegExp('(\\?|&)mp=([^&]*)(&|$)'));
  const webViewIsMp = window.localStorage && !!localStorage.getItem('webViewIsMp');
  return window.__wxjs_environment === 'miniprogram' || isMp || webViewIsMp;
}
export function isIOSMiniProgram() {
  return isIOS() && isMiniProgram();
}
// 是否课堂小程序
export function isWeAppke() {
  return query('sfrom') === 'weappke';
}

export function isMobile() {
  return /iPhone|iPod|Android|iPad/i.test(_userAgent);
}
